module.exports = __webpack_public_path__ + "static/media/dianzihetong.402f5190.png";


//////////////////
// WEBPACK FOOTER
// ./src/authCertificateCompact/ACEntrance/image/dianzihetong.png
// module id = 877
// module chunks = 0